import { render, staticRenderFns } from "./DocumentsManagementView.vue?vue&type=template&id=390bc539&scoped=true"
import script from "./DocumentsManagementView.vue?vue&type=script&lang=js"
export * from "./DocumentsManagementView.vue?vue&type=script&lang=js"
import style0 from "./DocumentsManagementView.vue?vue&type=style&index=0&id=390bc539&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390bc539",
  null
  
)

export default component.exports